import _ from 'lodash'
import React from 'react'
import {object, shape, arrayOf} from 'prop-types'

import {decimalToFraction} from '../utils'
import {default as MapComponent} from '../components/map'
import Button from '../components/button'
import Image from '../components/image'
import Video from '../components/video'
import Gallery from '../components/gallery'
import {H1, H2, H3, H4, H5, H6, P, A, I, EM, Strong, HR} from '../components/common'

// Construct a map of [originalName] -> imageFluidData
const makeImageMap = images => {
  const imageData = _.map(_.compact(images), 'childImageSharp.fluid')
  return _.reduce(
    imageData,
    (map, {originalName, ...fluidData}) => ({
      ...map,
      [originalName]: fluidData,
    }),
    {}
  )
}

const CustomComponents = (props = {}) => {
  const imageMap = makeImageMap(props.images) || {}
  return {
    h1: H1,
    h2: H2,
    h3: H3,
    h4: H4,
    h5: H5,
    h6: H6,
    p: P,
    a: A,
    i: I,
    em: EM,
    strong: Strong,
    hr: HR,
    button: Button,
    map: MapComponent,
    gallery: galleryProps => {
      let photos = []
      try {
        photos = JSON.parse(galleryProps.photos)
      } catch (e) {}
      // Transform gatsby-plugin-sharp fluid properties into react-photo-gallery properties
      // - Convert aspectRatio decimal to fraction
      const newPhotos = _.map(photos, ({src}) => {
        const imageData = imageMap[src]
        if (!imageData) return null

        const {numerator: width, denominator: height} = decimalToFraction(imageData.aspectRatio)
        // Remove these fields to Gallery>img
        delete imageData.originalImg
        delete imageData.aspectRatio
        delete imageData.base64
        // Add height/width values for Gallery
        return {
          ...imageData,
          width,
          height,
        }
      })
      return <Gallery photos={newPhotos} />
    },
    img: imgProps => {
      const fluid = imageMap[imgProps.src]
      return <Image fluid={fluid} caption={imgProps.caption} />
    },
    video: videoProps => {
      let sourcesArr = []
      try {
        sourcesArr = JSON.parse(videoProps.sources)
      } catch (e) {}

      const newProps = {
        ...props,
        controls: videoProps.controls === 'true',
        sources: sourcesArr,
      }
      return <Video {...newProps} />
    },
  }
}

CustomComponents.propTypes = {
  images: arrayOf(
    shape({
      childImageSharp: object.isRequired,
    })
  ),
}
export default CustomComponents
